export const reports = {
  All_reports: "Todos os relatórios",
  Areas_for_Improvement: "Áreas de Melhoria",
  Assessment: "Avaliação",
  Assessment_of_Conformity: "Avaliação de Conformidade",
  Assessment_Detail_Report_Link: "Link para o Relatório Detalhado de Avaliação",
  Conformity_Level: "Nível de Conformidade",
  Conformity_levels_may_have_been_adjusted:
    "Observe que os níveis de conformidade neste relatório resumido de padrão podem ter sido ajustados para atender às diretrizes de cada organização de padrão, o que pode resultar em um nível de conformidade diferente do avaliado originalmente.",
  aggregate_levels: {
    label: "Agregar nível de conformidade para",
    requirement: "Requisito",
    sub_section: "Subseção",
    section: "Seção",
  },
  custom_report: {
    Add_report_name: "Adicionar nome do relatório",
    aggregated: "Agregado",
    Are_you_sure_you_want_to_delete_report: "Tem certeza de que deseja excluir este relatório?",
    Are_you_sure_you_want_to_modify_report_name: "Tem certeza de que deseja modificar o nome do relatório?",
    Conformity_level: "Nível de conformidade",
    Create_Custom_Report: "Criar relatório personalizado",
    Download_entire_table: "Baixar tabela completa",
    "Download_filtered_&_customized_table": "Baixar tabela filtrada e personalizada",
    Export_to_file: "Exportar para arquivo",
    Name_cannot_be_empty: "O nome não pode estar vazio",
    Please_define_data_for_your_custom_report: "Por favor, defina os dados para seu relatório personalizado",
    Report_name: "Nome do relatório",
    requirement: "Requisito",
    section: "Seção",
    section_ref: "Ref. da seção",
    Select_an_assessment: "Selecionar uma avaliação",
    Select_sites_and_facilities: "Selecionar sites e instalações",
    Select_standards: "Selecionar padrões",
    standard_name: "Nome do padrão",
    standard_reference: "Referência do padrão",
    sub_section: "Subseção",
    sub_section_ref: "Ref. da subseção",
    This_action_cannot_be_undone: "Esta ação não pode ser desfeita",
    This_file_will_contain_report_based_on_all_the_customizations_and_filters_you_have_applied:
      "Este arquivo conterá o relatório com base em todas as personalizações e filtros que você aplicou",
    This_file_will_contain_whole_report: "Este arquivo conterá o relatório completo",
    Use_this_window_to_create_multi_site_multi_standard_report:
      "Use esta janela para criar um relatório multi-site e multi-padrão",
  },
  Custom_Reports: "Relatórios Personalizados",
  Customize_table: "Personalizar tabela",
  Download_entire_report: "Baixar relatório completo",
  Download_filtered_customized_report: "Baixar relatório filtrado e personalizado",
  Download_report: "Baixar relatório",
  Evidence: "Evidência",
  Evidence_Description: "Descrição da Evidência",
  filteredRecords_Results: "{{filteredRecords}} Resultados",
  Group_by: "Agrupar por",
  Group_by_assessment: "Agrupar por avaliação",
  Group_by_site: "Agrupar por site",
  In_progress: "Em andamento",
  Internal_audit_required: "Auditoria interna",
  IRMA_Achievement_Level: "Nível de Realização IRMA",
  Please_select_the_preferred_format: "Por favor, selecione o formato preferido",
  Protocol_ID: "ID do Protocolo",
  Protocol_Question: "Questão de Protocolo",
  Reference: "Referência",
  Reports: "Relatórios",
  Requirement: "Requisito",
  Reset_to_default: "Redefinir para padrão",
  Section: "Seção",
  Section_ref: "Ref. da seção",
  Site_name: "Nome do site",
  Stakeholder_approval_required: "Engajamento das Partes Interessadas",
  Standard: "Padrão",
  Standard_Reference: "Referência do Padrão",
  Status: "Status",
  Sub_Section: "Subseção",
  Sub_Section_Ref: "Ref. da Subseção",
  Sub_Theme: "Subtema",
  Table_customization: "Personalização da tabela",
  Theme: "Tema",
  This_assessment_is_in_progress_The_assessment_data_you_are_viewing_are_subject_to_change:
    "Esta avaliação está em andamento. Os dados de avaliação que você está visualizando estão sujeitos a alterações.",
  This_report_will_contain_all_protocol_questions_for_title_for_siteName:
    "Este relatório conterá todas as questões de protocolo para {{- title}} para {{- siteName}}.",
  This_report_will_contain_protocol_questions_for_title_for_siteName_based_on_all_the_customizations_and_filters_you_have_applied:
    "Este relatório conterá questões de protocolo para {{- title}} para {{- siteName}} com base em todas as personalizações e filtros que você aplicou",
  totalRecords_Results: "{{totalRecords}} Resultados",
} as const;
